module.exports = __webpack_public_path__ + "img/logo.bf1adf85.png";